import zElTable from './src/main.vue';
zElTable.install = (Vue) => {
	Vue.component(zElTable.name, zElTable);
};
export default zElTable;
